import { Text, type TextProps } from "@mantine/core";
import { useTheme } from "@contexts/ThemeContext";
import type { ReactNode } from "react";

interface JarvisTextProps extends Omit<TextProps, 'children'> {
  children?: ReactNode;
}

/**
 * JarvisText - A themed Text component that automatically applies
 * the current theme colors to match the application's design system.
 *
 * Usage: Use this instead of Mantine's Text to get automatic theming.
 */
export const JarvisText = ({ children, ...props }: JarvisTextProps) => {
  const { colors: themeColors } = useTheme();

  return (
    <Text
      {...props}
      style={{
        color: themeColors.text,
        ...props.style,
      }}
    >
      {children}
    </Text>
  );
};

export default JarvisText;
